namespace Portico.Services {
    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;

    export interface ISpinnerOverrideService {
        withoutUntil<T>(action: () => ng.IPromise<T>): ng.IPromise<T>;
    }

    @Service('app', 'spinnerOverrideService')
    @Inject('$rootScope')
    class SpinnerOverrideService implements ISpinnerOverrideService {
        constructor(private $rootScope: ng.IRootScopeService) { }

        withoutUntil<T>(action: () => ng.IPromise<T>): ng.IPromise<T> {
            (this.$rootScope as any).spinnerDisabled = true;
            return action().finally(() => (this.$rootScope as any).spinnerDisabled = false);
        }
    }
}